import { getMonthAndYearFromDate } from './date';
import { GhostPost } from '../models/ghost';

export function getPostPath(slug: string, publishedDate: string) {
  const { month, year } = getMonthAndYearFromDate(publishedDate);

  const slugMatcher = /^-(?:blog|advice)-[0-9]{4}-[0-9]{2}-/;
  const parsedSlug = slug.replace(slugMatcher, '');
  return `/${year}/${month}/${parsedSlug}`;
}

export function getAbsolutePostPath(
  slug: string,
  publishedDate: string,
  primaryTagSlug: string
) {
  const postPath = getPostPath(slug, publishedDate);
  const inferredChannel = primaryTagSlug.startsWith('blog') ? 'blog' : 'advice';
  return `https://www.kalibrr.com/${inferredChannel}${postPath}`;
}

export function getPostExcerpt(post: GhostPost) {
  return post.custom_excerpt || post.excerpt || '';
}
